import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IngredientChoice, IngredientChoiceGroup, IngredientChoicesType } from 'ngx-web-api';
import { ViewportService } from 'app/core/services/viewport.service';
import { ViewPort } from 'app/domain/view-port.model';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'fts-item-editor-modal-footer',
  templateUrl: './item-editor-modal-footer.component.html',
  styleUrls: ['./item-editor-modal-footer.component.scss'],
})
export class ItemEditorModalFooterComponent implements OnInit {
  @Input()
  hasBackBtn: boolean;
  @Input()
  hasForwardBtn: boolean;
  @Input()
  hasSubmitBtn: boolean;
  @Input()
  forwardBtnItemLabel: string;
  @Input()
  submitBtnLabel: string;
  @Input()
  forwardBtnDisabled: boolean;
  @Input()
  isItemValid: boolean;
  @Input()
  submitLoadingSubscription: Subscription;
  @Input()
  selectedChoiceGroup: IngredientChoiceGroup;
  @Input()
  ingredientChoicesType: IngredientChoicesType;
  @Input()
  hasChoiceGroups: boolean;
  @Input()
  selectedChoice: IngredientChoice;
  @Input()
  isHalfAndHalf = false;

  @Output()
  backBtnClick = new EventEmitter<void>();
  @Output()
  forwardBtnClick = new EventEmitter<void>();
  @Output()
  submitBtnClick = new EventEmitter<void>();
  @Output()
  cancelBtnClick = new EventEmitter<void>();

  @ViewChild('footer', { static: false })
  footer: ElementRef;

  footerTopPosition = 0;
  footerWidth = 0;
  viewPort$: Observable<ViewPort>;
  ingredientChoicesTypeEnum = IngredientChoicesType;
  choiceGroupsHeight: any;

  constructor(public viewportService: ViewportService) {}

  ngOnInit(): void {
    this.viewPort$ = this.viewportService.viewport$;
  }

  onBackBtnClick() {
    this.backBtnClick.emit();
  }

  onForwardBtnClick() {
    this.forwardBtnClick.emit();
  }

  onSubmitBtnClick() {
    this.submitBtnClick.emit();
  }

  onCancelBtnClick() {
    this.cancelBtnClick.emit();
  }
}
